export default __webpack_public_path__ + "static/14-5308adaeeae7bfcc53480d19f93524d4.png";